// extracted by mini-css-extract-plugin
export default {"alignLeft":"HTMLField_alignLeft__PN-PK"};